import styled from 'src/styles/theme';
import { ModalPostalCodeStyled } from '../ModalPostalCodeStyled';

export const ModalPostalCodeStyledDS = styled(ModalPostalCodeStyled)`
    .title {
        font-size: ${({ theme }) => theme.fontSizes.h3};
    }
    
    .description {
        font-size: ${({ theme }) => theme.fontSizes.h5};
    }
    
    .input {
        button {
            font-weight: ${({ theme }) => theme.fontWeights.textRegular};
            font-size: ${({ theme }) => theme.fontSizes.h5};
            text-transform: uppercase;
            
            &:hover {
                background: ${({ theme }) => theme.colors.primaryHover};
            }
        }
    }
`;
